import {useGetUniversityFeaturesQuery} from "ubcommunity-shared/src/types";
import {useIsFeatureEnabledBoolean} from "../Hooks/useIsFeatureEnabledBoolean";
import {FeatureFlags} from "../featureFlags";
import {useDiscoverableUniversity} from "./useDiscoverableUniversity";
import {CustomAttributesSection} from "./CustomAttributesSection";

const PROSPECT_CUSTOM_ATTRIBUTES_ENABLED = "customProspectSignupAttributes";

export function CustomAttributesFormFields({universityId}: {universityId: string}) {
    const {university} = useDiscoverableUniversity(universityId);

    const shouldRenderCustomAttributes = useIsFeatureEnabledBoolean(
        FeatureFlags.CUSTOM_ATTRIBUTES_IN_SECOND_STAGE_SIGNUP,
    );

    const {data: features} = useGetUniversityFeaturesQuery({
        variables: {
            universitySlug: university?.slug,
        },
        skip: !university?.slug,
    });

    const universityContentValues = features?.university?.config?.features?.find(
        (item) => item?.feature?.name === PROSPECT_CUSTOM_ATTRIBUTES_ENABLED,
    );
    const customAttributesEnabled =
        universityContentValues?.enabledByUnibuddy && universityContentValues?.enabledByUniversity;

    if (!customAttributesEnabled || !shouldRenderCustomAttributes) return null;

    return <CustomAttributesSection attributes={university?.customAttributes ?? []} />;
}
